import React, { useState, useEffect } from 'react';
import {
  FlexBox,
  FlexBoxHorizontal,
  TextField,
} from '../../atoms';
import {
  SearchButton,
  SelectAllCheckBox,
} from '../../molecules';
import { Filter } from '../../organisms';
import { styled } from 'styled-components';
import i18n from '../../../utils/i18n';

const ExcelDownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  height: 24px;
  min-width: 58px;
  background: ${props => props.$isDownloading ? '#e0e0e0' : 'rgb(136, 136, 136)'};
  color: ${props => props.$isDownloading ? '#999' : 'white'};
  border: none;
  border-radius: 6px;
  cursor: ${props => props.$isDownloading ? 'not-allowed' : 'pointer'};
  font-family: 'NotoSansKR-Regular', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 10px !important;
  line-height: 1;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    background:rgba(90, 98, 104, 0.89);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  
  &:active:not(:disabled) {
    background: #495057;
    transform: translateY(0.5px);
  }
  
  &:disabled {
    opacity: 1;
  }
  
  span {
    font-size: 11px !important;
    line-height: 1;
    letter-spacing: 0.3px;
  }
`;

const UploadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  height: 24px;
  min-width: 58px;
  background: #495057;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-family: 'NotoSansKR-Regular', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 10px !important;
  line-height: 1;
  transition: all 0.2s ease;
  
  &:hover { background: #3a7bc8; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); }
  &:active { background: #2d6cb5; transform: translateY(0.5px); }
  
  span { font-size: 11px !important; line-height: 1; letter-spacing: 0.3px; }
`;

const SaveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  height: 24px;
  min-width: 58px;
  background: #d32f2f;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-family: 'NotoSansKR-Regular', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 10px !important;
  line-height: 1;
  transition: all 0.2s ease;
  
  &:hover { background: #b71c1c; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); }
  &:active { background: #9a0007; transform: translateY(0.5px); }
  
  span { font-size: 11px !important; line-height: 1; letter-spacing: 0.3px; }
`;

const CadDataFilter = ({ data, onSearch, downloadExcel, isUploadPage, downloadFormat, onUpload, onSave, hasUnsavedChanges }) => {
      const language = i18n.language;
      
      const filterOptions = {
            ...data,
            searchValue: null,
          };
      const [selectedOptions, setSelectedOptions] = useState([]);

      useEffect(() => {
        const newSelectedOptions = {
          ...filterOptions,
          sesn: [{value: '26F', label: '26F'}],
        };
    
        setSelectedOptions(newSelectedOptions);
        onSearch(newSelectedOptions);
      }, [data]);
    

      const handleSelectedOptions = (key, value) => {
            setSelectedOptions((prev) => ({
              ...prev,
              [key]: value,
            }));
            onSearch({ ...selectedOptions, [key]: value });
          };


  return (
      <Filter style={{ height: '60px', flexDirection: 'column' }}>
      <FlexBoxHorizontal style={{ justifyContent: 'space-between', overflow: 'auto' }}>
          <FlexBox>
          {data.designer.length > 0 ? <>
            <div
            style={{
              width: '170px',
              margin: '0 10px 0 20px',
            }}

          >
            <SelectAllCheckBox
              selected={selectedOptions.sesn}
              setSelected={(value) => handleSelectedOptions('sesn', value)}
              options={filterOptions.sesn}
              title={'시즌'}
              allSelectTitle="시즌 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '170px',
              marginRight: '10px',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.sex}
              setSelected={(value) => handleSelectedOptions('sex', value)}
              options={filterOptions.sex}
              title={'성별'}
              allSelectTitle="성별 All"
              isMulti
            />
          </div> 
          <div
            style={{
              width: '160px',
              marginRight: '10px',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.class1}
              setSelected={(value) => handleSelectedOptions('class1', value)}
              options={filterOptions.class1}
              title={'대분류'}
              allSelectTitle="대분류 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '160px',
              marginRight: '10px',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.class2}
              setSelected={(value) => handleSelectedOptions('class2', value)}
              options={filterOptions.class2}
              title={'중분류'}
              allSelectTitle="중분류 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '160px',
              marginRight: '10px',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.item}
              setSelected={(value) => handleSelectedOptions('item', value)}
              options={filterOptions.item}
              title={'아이템'}
              allSelectTitle="아이템 All"
              isMulti
            />
          </div> 
          <div
            style={{
              width: '170px',
              marginRight: '10px',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.designer}
              setSelected={(value) => handleSelectedOptions('designer', value)}
              options={filterOptions.designer}
              title={'디자이너'}
              allSelectTitle="디자이너 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '170px',
              marginRight: '10px',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.fabInfo}
              setSelected={(value) => handleSelectedOptions('fabInfo', value)}
              options={filterOptions.fabInfo}
              title={'소재명'}
              allSelectTitle="소재명 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '200px',
              marginRight: '10px',
            }}
          >
            <TextField
              placeholder="코드/제품명/컬러"
              onChange={(value) => handleSelectedOptions('searchValue', value)}
            />
          </div>
          </>: null}
          </FlexBox> 
          <FlexBox style={{ gap: '8px', alignItems: 'center', paddingRight: '16px' }}>
            {isUploadPage ? (
              <>
                <ExcelDownloadButton onClick={downloadFormat}>
                  <span>FORMAT</span>
                </ExcelDownloadButton>
                <ExcelDownloadButton onClick={() => downloadExcel()}>
                  <span>DATA</span>
                </ExcelDownloadButton>
                <ExcelDownloadButton onClick={onUpload}>
                  <span>UPLOAD</span>
                </ExcelDownloadButton>
                {hasUnsavedChanges && (
                  <SaveButton onClick={onSave}>
                    <span>SAVE</span>
                  </SaveButton>
                )}
              </>
            ) : (
              <ExcelDownloadButton onClick={() => downloadExcel()}>
                <span>EXCEL DOWNLOAD</span>
              </ExcelDownloadButton>
            )}
          </FlexBox>
          </FlexBoxHorizontal>
      </Filter>
  );
};

export default CadDataFilter;
